import './styles/globals.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { FeatureFlagProvider } from './contexts/FeatureFlagContext';
import { LaunchDarklyProvider } from './contexts/LaunchDarklyContext';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LaunchDarklyProvider>
          <FeatureFlagProvider>
            <App />
          </FeatureFlagProvider>
        </LaunchDarklyProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
